import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { LoginAnnouncementMutationKeys } from '../../../keys'
import {
	CreateLoginAnnouncementRequest,
	CreateLoginAnnouncementResponse,
} from '../../../type'
import { createLoginAnnouncement } from '../../services'

interface UseMutationCreateLoginAnnouncementProps {
	payload: CreateLoginAnnouncementRequest
}

export default function useMutationCreateLoginAnnouncement(
	props?: UseBaseMutationOptions<
		CreateLoginAnnouncementResponse,
		UseMutationCreateLoginAnnouncementProps
	>,
) {
	return useMutation({
		mutationKey: [LoginAnnouncementMutationKeys.CreateLoginAnnouncement],
		mutationFn: (params) => createLoginAnnouncement(params.payload),
		...props,
	})
}
